import React from "react";
import logo from "../../../assets/images/image.png";
import bgImage from "../../../assets/images/bgImage.png";
import Styles from "./withAuth.module.scss";
import { testIdProps } from "../../../utils/testIdProps";

const WithAuthLayout = (WrappedComponent: React.FC) => {
  const AuthLayout: React.FC = () => {
    return (
      <>
        <div className={`min-vh-100 min-vw-100 ${Styles.container}`}>
          <div style={{ height: "100vh" }}>
            <img src={bgImage} alt="background" className={`${Styles.image}`} />
          </div>

          <section className={`${Styles.ui}`}>
            <nav className="navbar navbar-light sticky-top px-5 py-2">
              <a
                {...testIdProps("auth-layout-home-link")}
                className="navbar-brand d-flex align-items-center"
                href="/"
              >
                <img
                  src={logo}
                  alt="Logo"
                  className=""
                  height={35}
                  style={{ objectFit: "contain" }}
                />
              </a>
            </nav>
            <div
              style={{
                padding: "0px 120px",
                height: "calc(100vh - 65px)",
              }}
              className={`d-flex align-items-center overflow-hidden justify-content-between`}
            >
              {/* text - hidden on mobile & tablet */}
              <div
                className="d-none d-lg-flex flex-column"
                style={{
                  width: 458,
                  height: 214,
                  gap: 24,
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    width: 458,
                    height: 128,
                    fontFamily: "'Geist', sans-serif",
                    fontWeight: 900,
                    fontSize: 64,
                    lineHeight: "64px",
                    letterSpacing: 0,
                    background:
                      "linear-gradient(90deg, rgba(0, 0, 0, 1) 5%,  rgba(33, 255, 145, 0.83) 100%,  rgba(0, 253, 127, 0) 0%)",
                    backgroundSize: "100%",
                    backgroundRepeat: "no-repeat",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  <p style={{ margin: 0 }}>
                    Trusted by
                    <br />
                    500+ brands
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      width: 458,
                      height: 128,
                      fontWeight: 400,
                      fontFamily: "'Geist', sans-serif",
                      fontSize: 24,
                      letterSpacing: 0,
                      lineHeight: "30px",
                      color: "#515151",
                      margin: 0,
                    }}
                  >
                    We create digital-first solutions to solve toughest industry
                    challenges.
                  </p>
                </div>
              </div>

              <div
                style={{
                  minWidth: "500px",
                }}
              >
                <WrappedComponent />
              </div>
            </div>
          </section>
        </div>
        {/* Sticky Navbar */}
      </>
    );
  };

  return AuthLayout;
};

export default WithAuthLayout;
